<template>
    <div>
        <template v-if="canUseSocialPublish">
            <v-row>
                <v-col cols="5">
                    <SearchTextfield
                        :search="search"
                        :dispatch-to-store="false"
                        :placeholder="$store.getters.t('social.history.search_placeholder')"
                        @input="handleSearchInput"
                    />
                </v-col>

                <v-col class="text-right mb-2">
                    <IconButton icon="mdi-refresh" class="mr-2 mb-2" @click="refresh" :loading="loading" small />
                    <TextButton
                        icon="mdi-link-variant"
                        :buttonText="$store.getters.t('social.integration.button.manage')"
                        class="mr-2 mb-2"
                        isPrimary
                        @click="goToIntegrations"
                    />
                </v-col>
            </v-row>

            <SocialUploadTable
                :loading="loading"
                :search="search"
                :items="tasks"
            />
        </template>
        <div v-else class="locked-info pa-6 text-center">
            <v-icon size="48" color="grey darken-1" class="mb-3">mdi-lock-outline</v-icon>
            <h3 class="mb-2">{{ $store.getters.t ? $store.getters.t('social.history.locked.title') : '소셜 업로드 이력을 확인하려면 업그레이드가 필요합니다.' }}</h3>
            <p class="mb-0">
                {{ $store.getters.t ? $store.getters.t('social.history.locked.description') : '상위 플랜으로 전환하면 소셜 업로드 기록과 큐 상태를 모두 살펴볼 수 있습니다.' }}
            </p>
        </div>

        <AppSnackbar
            :message="snackbarMessage"
            :visible="snackbar"
            :error="snackbarError"
        />
    </div>
</template>

<script>
// ui 컴포넌트 import
import IconButton from '@/components/ui/button/IconButton.vue';
import TextButton from '@/components/ui/button/TextButton.vue';
import SearchTextfield from '@/components/ui/form/SearchTextfield.vue';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";

// 요소 컴포넌트 import
import SocialUploadTable from "@/components/socialupload/SocialUploadTable.vue";

// api & back import
import SocialApi from '@/api/social/SocialApi';

export default {
    components: {
        // ui 컴포넌트
        IconButton,
        TextButton,
        SearchTextfield,
        AppSnackbar,

        // 요소 컴포넌트
        SocialUploadTable,

    },
    data() {
        return {
            search: '',
            loading: false,
            tasks: [],
            snackbar: false,
            snackbarMessage: '',
            snackbarError: false,
            snackbarTimer: null,
        };
    },
    computed: {
        canUseSocialPublish() {
            return this.$store.getters['naviList/hasSocialPublish'];
        }
    },
    watch: {
        canUseSocialPublish: {
            immediate: true,
            handler(isAllowed) {
                if (isAllowed) {
                    this.fetchTasks();
                } else {
                    this.loading = false;
                    this.tasks = [];
                }
            }
        }
    },
    methods: {
        async fetchTasks() {
            if (!this.canUseSocialPublish) {
                this.loading = false;
                this.tasks = [];
                return;
            }
            this.loading = true;
            try {
                const response = await SocialApi.fetchPublishTasks();
                this.tasks = Array.isArray(response) ? response : [];
            } catch (error) {
                console.error('[SocialUpload] failed to load tasks', error);
                const message = error?.response?.data?.message
                    || this.$store.getters.t('social.history.error.fetch_list');
                this.showSnackbar(message, true);
                this.tasks = [];
            } finally {
                this.loading = false;
            }
        },
        refresh() {
            if (!this.canUseSocialPublish) {
                return;
            }
            this.fetchTasks();
        },
        handleSearchInput(value) {
            this.search = value;
        },
        goToIntegrations() {
            this.$router.push('/settings/social');
        },
        showSnackbar(message, isError = false) {
            this.snackbarMessage = message;
            this.snackbarError = isError;
            this.snackbar = true;
            if (this.snackbarTimer) {
                clearTimeout(this.snackbarTimer);
            }
            this.snackbarTimer = setTimeout(() => {
                this.snackbar = false;
                this.snackbarTimer = null;
            }, 3000);
        },
    },
    beforeDestroy() {
        if (this.snackbarTimer) {
            clearTimeout(this.snackbarTimer);
            this.snackbarTimer = null;
        }
    },
}
</script>

<style scoped>
.locked-info {
    border: 1px dashed #d1d5db;
    border-radius: 12px;
    background: #f9fafb;
    color: #4b5563;
}
</style>
